export const AI_MODELS = [
  { name: "opus-47",              displayName: "Opus 4.7",                value: "opus-47"              },
  { name: "opus-46",              displayName: "Opus 4.6",                value: "opus-46"              },
  { name: "sonnet-46",            displayName: "Sonnet 4.6",              value: "sonnet-46"            },
  { name: "gemini-31-pro",        displayName: "Gemini 3.1 Pro",          value: "gemini-31-pro"        },
  { name: "gemini-31-flash-lite", displayName: "Gemini 3.1 Flash Lite",   value: "gemini-31-flash-lite" },
  { name: "gpt-52",               displayName: "GPT 5.2",                 value: "gpt-52"               },
] as const;

export type AIModelKey = typeof AI_MODELS[number]["value"];
